export const NotDataIcon = () => (
	<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g id="Image / Illustration / Animated / Timer">
			<circle id="Back" cx="30" cy="30" r="30" fill="#B8B8BB" />
			<path
				id="Check"
				d="M33.5 25L29 32L34 34.5"
				stroke="white"
				strokeWidth="5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				id="Ellipse 91"
				d="M30 15.6842C21.7157 15.6842 15 22.4706 15 30.8421C15 39.2136 21.7157 46 30 46C38.2843 46 45 39.2136 45 30.8421C45 26.6018 43.277 22.7682 40.5 20.0172M30 15.6842L25.5 22.8842M30 15.6842L24 10"
				stroke="white"
				strokeWidth="5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
	</svg>
);
